"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterstitialKind = exports.isSeatingKind = void 0;
const t = __importStar(require("io-ts"));
/** for pieces that can be sat on
 * The unusual array as string literal types thing here allows us to make a typeguard without
 * repeating literals anywhere
 */
const seatingKinds = ['sofa-end-left', 'sofa-end-right', 'straight', 'corner'];
function isSeatingKind(kind) {
    return seatingKinds.indexOf(kind) >= 0;
}
exports.isSeatingKind = isSeatingKind;
exports.InterstitialKind = t.keyof({ 'drinks-cooler-armrest': null });
